import { css } from 'styled-components';
export default {
    montserrat: {
        light: css `
      font-family: 'Montserrat', sans-serif;
      font-style: normal;
      font-weight: 300;
    `,
        lightItalic: css `
      font-family: 'Montserrat', sans-serif;
      font-weight: 300;
      font-style: italic;
    `,
        regular: css `
      font-family: 'Montserrat', sans-serif;
      font-style: normal;
      font-weight: 400;
    `,
        regularItalic: css `
      font-family: 'Montserrat', sans-serif;
      font-weight: 400;
      font-style: italic;
    `,
        medium: css `
      font-family: 'Montserrat', sans-serif;
      font-style: normal;
      font-weight: 500;
    `,
        mediumItalic: css `
      font-family: 'Montserrat', sans-serif;
      font-weight: 500;
      font-style: italic;
    `,
        bold: css `
      font-family: 'Montserrat', sans-serif;
      font-style: normal;
      font-weight: 700;
    `,
        boldItalic: css `
      font-family: 'Montserrat', sans-serif;
      font-weight: 700;
      font-style: italic;
    `,
    },
    lustria: {
        regular: css `
      font-family: 'Lustria', serif;
      font-style: normal;
      font-weight: 400;
    `,
    },
};
